import { createSelector } from '@reduxjs/toolkit';

import { Insertion, LayoutModel } from '@paragon/contract-library';
import { notNullish, ReadonlyRecord } from '@paragon/utilities';

import { getInsertionsWithPendingChangesGroupedByParentGuid, getLayoutModelsWithPendingChanges } from './changeTracker';

export type ChildrenFinder = (modelGuid: string) => readonly LayoutModel[];

export function createChildrenFinder(
  insertionsGroupedByParentGuid: ReadonlyRecord<string, readonly Insertion[] | undefined>,
  layoutModels: ReadonlyRecord<string, LayoutModel | undefined>,
) {
  return (parentGuid: string) =>
    insertionsGroupedByParentGuid[parentGuid]
      ?.map((insertion) => layoutModels[insertion.objectGuid])
      .filter(notNullish) ?? [];
}

export const getChildrenFinder = createSelector(
  getInsertionsWithPendingChangesGroupedByParentGuid,
  getLayoutModelsWithPendingChanges,
  createChildrenFinder,
);
